let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1fpVy")).then(() => parcelRequire('cVpTe'));